import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ErrorHandlerService } from '@examdojo/core/error-handling';
import { mapToVoid } from '@examdojo/core/rxjs';
import { PayoutRatesService } from '@examdojo/payments';
import { UserQuery } from '@examdojo/user';
import { EMPTY } from 'rxjs';
import { filter, first, switchMap } from 'rxjs/operators';

export const userHourlyRateResolver: ResolveFn<void> = () => {
  const errorHandlerService = inject(ErrorHandlerService);
  const payoutRatesService = inject(PayoutRatesService);
  const userQuery = inject(UserQuery);

  return userQuery.active$.pipe(
    filter(Boolean),
    first(),
    switchMap((user) => payoutRatesService.fetchUserRates(user.id)),
    errorHandlerService.catchError('Error fetching user hourly rates', () => EMPTY, {
      toast: 'Error fetching user hourly rates',
    }),
    mapToVoid(),
  );
};
